import type React from 'react'
import type { JSX } from 'react'
import type { IRowContainerProps, RowPaddings } from '../RowContainer.h'

import { useMemo } from 'react'
import { InlineForwardArrowWithTitle } from 'atoms/Button/Templates'
import { IconNames } from 'atoms/Icon'
import { ContainerHeaderWithTitleDescription } from 'blocks/Container/Header/Templates'
import { RowTitleSC } from '../NewRowContainer.styled'
import { RowControlsType } from '../RowContainer.h'
import { HeaderControls } from './HeaderControls'

export interface IRowTitleDescription extends Omit<
  IRowContainerProps,
  'itemCount' | 'cardAspectRatio' | 'children' | 'visibleCards'
> {
  children?: React.ReactNode
  childrenType?: string
  currentIndex?: number
  nextButtonVisible: boolean
  prevButtonVisible: boolean
  prev: () => void
  next: () => void
  onSeeAllClick?: () => void
  isRenderSpecialCell?: boolean
  paddings?: (typeof RowPaddings)[keyof typeof RowPaddings]
}

const ButtonSeeAll = ({
  buttonTitle,
  onSeeAllClick,
}: {
  buttonTitle?: string
  onSeeAllClick?: () => void
}): JSX.Element => (
  <InlineForwardArrowWithTitle
    title={buttonTitle}
    onClick={onSeeAllClick}
    icon={IconNames.angleRight}
  />
)

export const RowTitleDescription = ({
  children,
  controlsType = RowControlsType.inRowFluid,
  currentIndex,
  titleColor,
  title,
  nextButtonVisible,
  prevButtonVisible,
  prev,
  next,
  buttonTitle,
  onSeeAllClick,
  isMoreThanOnePage,
  description,
}: IRowTitleDescription): JSX.Element | null => {
  const controlsInHeader = useMemo(
    () => controlsType === RowControlsType.inHeader,
    [controlsType]
  )
  return children || title ? (
    <RowTitleSC>
      {children ? (
        children
      ) : (
        <ContainerHeaderWithTitleDescription
          title={title!}
          description={description}
          color={titleColor}
        >
          {controlsInHeader && (
            <HeaderControls
              currentIndex={currentIndex}
              nextButtonVisible={nextButtonVisible}
              prevButtonVisible={prevButtonVisible}
              prev={prev}
              next={next}
              controlsType={controlsType}
            />
          )}
          {isMoreThanOnePage && (
            <ButtonSeeAll
              onSeeAllClick={onSeeAllClick}
              buttonTitle={buttonTitle}
            />
          )}
        </ContainerHeaderWithTitleDescription>
      )}
    </RowTitleSC>
  ) : null
}

RowTitleDescription.displayName = 'RowTitleDescription'
